window.getAbsoluteUrl = (function() {
    var a;

    return function(url) {
        if(!a) a = document.createElement('a');
        a.href = url;

        return a.href;
    };
})();

require('./share.js');

$('.js-video').on('play', function () {
    $(this).fadeIn(1000);
    $(this).off('play');
});



//////////////////
// WEBPACK FOOTER
// ./pages/anniversary/js/index.js
// module id = 0
// module chunks = 1